import React from 'react';
import styled from 'styled-components';
import useLocalStorage from 'hooks/common/useLocalStorage';
import { useSelector } from 'react-redux';
export default function SurveyEnd({onComplete}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  useLocalStorage("matchingTutorial", true);//const [matchingTutorial,setMatchingTutorial] = 
  let handleNext = (e) => {
    if(onComplete)
    {
      onComplete();
    }
  }
  return (
    <SurveyWrapper>
      <HeaderWrapper>🙌</HeaderWrapper>
      <BodyWrapper>
          <StartTxt>
          질문에 답해주셔서 감사해요.<br />
        모티너스가 {userInfo['name']}님에게 <br />
        잘 맞는 친구를 추천해드릴게요!
          </StartTxt>
          <CompleteBtn onClick={handleNext}>
          다음
          </CompleteBtn>
      </BodyWrapper>
    </SurveyWrapper>
  );
}
const SurveyWrapper = styled.div`
  padding : calc(100vw * (17.5 / 375)) calc(100vw * (16 / 375)) 0 ;
`;
const HeaderWrapper = styled.div`
  font-weight: bold;
  font-size: calc(100vw * (40 / 375));
  line-height: calc(100vw * (58 / 375));
  margin-bottom : calc(100vw * (16 / 375));
`;
const BodyWrapper = styled.div`
`
const StartTxt = styled.p`
  font-weight: bold;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (29 / 375));
  color: #121212;
`
const CompleteBtn = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100vw * (72 / 375));
  bottom: 0;
  background: #FFCF19;
  z-index: 300;
  left: 0;
  line-height: calc(100vw * (72 / 375));
  text-align: center;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
`;
